'use client';
import styled from 'styled-components';
import Confetti from '../../images/onboarding/confetti.svg';

export const Wrapper = styled.div`
  background: ${props => props.theme.colors.background.base};
`;

export const InterstitialContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${props => props.theme.colors.background.base};
  background-image: url(${Confetti.src});
  background-attachment: local;
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: -75px;

  nav {
    background: transparent;
  }
`;

export const LoadingInterstitial = styled.div`
  flex-grow: 1;
  padding: ${props => props.theme.spacing(0, 4)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
